import { ORDER_TOKEN_VALIDITY, MANDATORY_SEARCH_PARAMS_ONEWAY, MANDATORY_SEARCH_PARAMS_ROUNDTRIP, MANDATORY_SEARCH_PARAMS_MULTISTOP, VALID_TRIP_TYPES } from "@flights/constants";
export const isValidLatinName = (name) => /^[a-z A-Z\u00C0-\u00ff]+([-'][a-z A-Z\u00C0-\u00ff]+)?$/g.test(name);
export function isTokenExpired(isodatetime) {
    const tokenCreationTime = Date.parse(isodatetime);
    const currentTime = Date.now();
    return (currentTime - tokenCreationTime) / 1000 > ORDER_TOKEN_VALIDITY;
}
export function isValidRelativeURL(url) {
    const baseUrl = "https://flights.booking.com/";
    const relativePath = url.replace(/^\/+/, "");
    const testURL = new URL(url, baseUrl);
    if (testURL.href == baseUrl + relativePath) {
        return true;
    }
    return false;
}
export const isValidSearchURL = (paramString, withPath) => {
    if (withPath) {
        paramString = paramString.split("?")[1];
    }
    const searchParams = new URLSearchParams(paramString);
    const tripType = searchParams.get("type");
    if (!tripType || !VALID_TRIP_TYPES.includes(tripType)) {
        return false;
    }
    const paramsToCheckAgainst = (() => {
        switch (tripType) {
            case "ONEWAY":
                return MANDATORY_SEARCH_PARAMS_ONEWAY;
            case "ROUNDTRIP":
                return MANDATORY_SEARCH_PARAMS_ROUNDTRIP;
            case "MULTISTOP":
                return MANDATORY_SEARCH_PARAMS_MULTISTOP;
            default:
                return MANDATORY_SEARCH_PARAMS_ONEWAY;
        }
    })();
    return paramsToCheckAgainst.every((param) => searchParams.get(param));
};
